import IconFilter from "../../components/icon/IconFilter";
import React from "react";
import {Popover, Transition} from "@headlessui/react";
import TableFilterPanel from "./TableFilterPanel";

export enum FilterBlockType {
  CHECKBOX = "CHECKBOX",
  SELECT = "SELECT",
  RADIO = "RADIO",
}

export class FilterState {
  constructor(readonly id: string, readonly active: boolean, readonly value: string) {
  }

  reset() {
    return new FilterState(this.id, false, '');
  }
}

export interface FilterBlock {
  id: string;
  title: string;
  type: FilterBlockType
}

type Props = {
  filters: FilterBlock[];
  states: FilterState[];
  onApply: (states: FilterState[]) => void
}

export default function TableFilter({filters, states, onApply}: Props) {
  const number = states.filter(f => f.active).length;

  return (
    <Popover className="relative z-10">
      {({open}) => (
        <>
          <Popover.Button className="ml-4 relative">
            <IconFilter className="h-5 mt-1 text-blue"/>
            {number > 0 &&
              <span
                className="ml-2 rounded-full text-white bg-blue font-bold text-xs px-1.5 absolute left-1 border-white -top-1 border-2">
        {number}</span>
            }
          </Popover.Button>
          <Transition
            show={open}
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <Popover.Panel static
                           className="origin-top-left absolute left-4 mt-2 w-64 rounded-md drop-shadow-md shadow-lg bg-white :outline-none">
              <TableFilterPanel filters={filters} states={states} onApply={onApply}/>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
}
